// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { Table as HeroTable } from "@heroui/react";
import { clsx } from "clsx";
import type { ComponentProps } from "react";

export type DataTableProps = ComponentProps<typeof HeroTable.Root>;

function DataTableRoot({
  className,
  variant = "secondary",
  ...props
}: DataTableProps) {
  return (
    <HeroTable.Root
      className={clsx("tapp-data-table", className)}
      variant={variant}
      {...props}
    />
  );
}

/**
 * PayDay's stable operations-ledger contract.
 *
 * HeroUI stays behind this compound adapter so feature routes can use React
 * Aria's sorting, selection and keyboard behavior without importing the
 * vendor package directly.
 */
export const DataTable = Object.assign(DataTableRoot, {
  Root: DataTableRoot,
  ScrollContainer: HeroTable.ScrollContainer,
  Content: HeroTable.Content,
  Header: HeroTable.Header,
  Column: HeroTable.Column,
  ColumnResizer: HeroTable.ColumnResizer,
  Body: HeroTable.Body,
  Row: HeroTable.Row,
  Cell: HeroTable.Cell,
  Footer: HeroTable.Footer,
  Collection: HeroTable.Collection,
  LoadMore: HeroTable.LoadMore,
  LoadMoreContent: HeroTable.LoadMoreContent,
  ResizableContainer: HeroTable.ResizableContainer,
  SortableColumnHeader: HeroTable.SortableColumnHeader,
});

export type DataTableContentProps = ComponentProps<typeof HeroTable.Content>;
export type DataTableHeaderProps = ComponentProps<typeof HeroTable.Header>;
export type DataTableColumnProps = ComponentProps<typeof HeroTable.Column>;
export type DataTableBodyProps = ComponentProps<typeof HeroTable.Body>;
export type DataTableRowProps = ComponentProps<typeof HeroTable.Row>;
export type DataTableCellProps = ComponentProps<typeof HeroTable.Cell>;
